import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppConfig from './config/AppConfig';
import TorUtils from './utils/TorUtils';
import SecuritySignalProtocolStoreInMemoryDB from "./services/SecuritySignalProtocolStoreInMemoryDB";
import ICPAuthProvider from './icp/authContext';
import { EthereumChains, SetupWizardState } from './utils/Types';
import Web3Helper from './common/Web3Helper';


const APP_TYPES = {
  PLEXI_MAIL: 0,
  PLEXI_SIGN: 1,
};

const notificationIsEnabled = true;
const activeAccount = localStorage['app.recent-active-account'];
if (activeAccount && activeAccount.length > 0) {
  const chainId = localStorage[`${activeAccount}.app.chain-id`];
  if (!chainId || chainId.length === 0) {
    window.chainId = EthereumChains.Default;
  } else {
    window.chainId = chainId;
  }
} else {
  const chainId = localStorage[`app.recent-chain-id`];
  if (!chainId || chainId.length === 0) {
    window.chainId = EthereumChains.Default;
  } else {
    window.chainId = chainId;
  }
}
function initialNetwork(newChainId) {
  if (newChainId === EthereumChains.Goerli) {
    Web3Helper.init('goerli');
  } else if (newChainId === EthereumChains.Mainnet) {
    Web3Helper.init('mainnet');
  } else if (newChainId === EthereumChains.Fuji){
    Web3Helper.init('fuji');
  } else if (newChainId === EthereumChains.Avalanche) {
    Web3Helper.init('avalanche');
  } else if (newChainId === EthereumChains.Sepolia) {

    // window.web3Helper.init('sepolia');

    const sepOpts = {
      // rpcUrl: 'https://rpc.sepolia.org', // your ethereum, polygon, or optimism mainnet/testnet rpc URL
      // rpcUrl: 'https://polygon-mumbai-infura.wallet.coinbase.com?targetName=ethereum-sepolia',
      rpcUrl: 'https://eth-sepolia.g.alchemy.com/v2/tApGyKU4AgHcem9l6xFsuMCdVe6mah6P',
      // rpcUrl: 'https://sepolia.rpc.thirdweb.com',
      chainId: 11155111
    }
    Web3Helper.init(sepOpts);
  } else {
    Web3Helper.init('fuji');
  }
  window.web3Helper = Web3Helper
}

const doRender = () => {
  // initialNetwork();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  // root.render(
  //   <React.StrictMode>
  //     <App />
  //   </React.StrictMode>
  // );
  root.render(
    <ICPAuthProvider>
      <App />
    </ICPAuthProvider>
  );
};

const resetIndexedDB = async() => {
  // return true;
  localStorage.clear();
  const dbs = await indexedDB.databases();
  const dbNames = dbs.map(db => db.name);
  const results = await Promise.allSettled(
    dbNames.map(name => {
      return new Promise((resolve, reject) => {
        const req = indexedDB.deleteDatabase(name);
        req.onsuccess = () => resolve({ name, status: 'deleted' });
        req.onerror = () => reject({ name, error: req.error });
        req.onblocked = () => reject({ name, error: 'blocked' });
      });
    })
  );
  
  results.forEach(result => {
    if (result.status === 'fulfilled') {
      console.log(`✓ 已删除: ${result.value.name}`);
    } else {
      console.error(`✗ 删除失败: ${result.reason.name} - ${result.reason.error}`);
    }
  });

  return true;
};

window.isBrave = false;

if (!window.inMemoryDB) {
  window.inMemoryDB = new SecuritySignalProtocolStoreInMemoryDB();
}
// if (!window.IndexedDBDriver) {
//   window.IndexedDBDriver = IndexedDBDriver;
// }
if (!window.appConfig) {
  window.appConfig = new AppConfig();
  // if (localStorage.getItem('initialization.mode') !== 'simple' && window.appConfig.setupWizardState !== SetupWizardState.Completed) {
  //   localStorage.setItem('initialization.mode', 'simple');
  // }
}

const url = new URL(window.location.href)
const lang = url.searchParams.get('lang');
const app = url.searchParams.get('app');
const src = url.searchParams.get('src');

if (src) {
  if (localStorage.getItem("src") !== src) {
    localStorage.setItem("src", src);
  }
}

if (lang) {
  if (localStorage.getItem("language") !== lang) {
    if (lang === 'en' || lang === 'zh' || lang === 'es') {
      localStorage.setItem("language", lang);
    }
  }
}

if (app) {
  const appType = app === 'pleximail' ? 0 : 1;
  if (localStorage.getItem("app.default.app") !== appType) {
    if (app === 'pleximail') {
      localStorage.setItem('app.default.app', APP_TYPES.PLEXI_MAIL)
    } else {
      localStorage.setItem('app.default.app', APP_TYPES.PLEXI_SIGN)
    }
  }
}

try {
  if (window.topbar) {
    window.topbar.hide();
  }
  document.body.className = 'loaded';
}catch(e) {}

if (window.navigator.brave) {
  window.navigator.brave.isBrave().then(isBrave => {
    window.isBrave = isBrave;
    return TorUtils.detect();
  }).then(result => {
    window.torInfo = result;
    return indexedDB.databases().then(databases => {
      const dbs = databases.filter(db => {
        return db.name === 'w3up@pleximail'
      })
      if (!dbs) {
        return null;
      }
      return dbs[0]
    })

  }).then(db => {
    if (!db) {
      return true;
    }
    return resetIndexedDB();
  }).then((result) => {
    doRender();
  }).catch((e) => {
    console.error(e);
    // showError(e);
  })
} else {
  TorUtils.detect().then((result) => {
    window.torInfo = result;
    return indexedDB.databases().then(databases => {
      const dbs = databases.filter(db => {
        return db.name === 'w3up@pleximail'
      })
      if (!dbs) {
        return null;
      }
      return dbs[0]
    })

  }).then(db => {
    if (!db) {
      return true;
    }
    return resetIndexedDB();
  }).then(result => {
    doRender();

  }).catch((e) => {
    console.error(e);
  })
}